import { Button, Box, CircularProgress } from '@mui/material';
import React from 'react';

interface IAsyncButton{
  disabled?: boolean;
  title: string;
  isLoading: boolean;
  onClick?: () => void;
  type?: "button" | "submit" | "reset" | undefined
}

const AsyncButton = (props: IAsyncButton) => {

  const { title, disabled = false, isLoading, onClick, type } = props;

  return (
    <Box position='relative'>
      <Button variant='contained'
        {...type && { type }}
        disabled={disabled || isLoading}
        onClick={onClick}>
        {title}
      </Button>
      {isLoading && (
        <CircularProgress
          size={24}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      )}
    </Box>
  );
};

export default AsyncButton;